"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepLabel = exports.StepNumber = exports.StepContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StepContainer = styled_components_1.default.div.attrs({
    className: "StepContainer",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  font-size: var(--font-size-s);\n  cursor: pointer;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  font-size: var(--font-size-s);\n  cursor: pointer;\n"])));
exports.StepNumber = styled_components_1.default.span.attrs({
    className: "StepNumber",
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  background-color: ", ";\n  width: 2.6rem;\n  height: 2.6rem;\n  border-radius: 6px;\n  padding: 0.4rem;\n  margin: auto;\n  color: ", ";\n"], ["\n  text-align: center;\n  background-color: ", ";\n  width: 2.6rem;\n  height: 2.6rem;\n  border-radius: 6px;\n  padding: 0.4rem;\n  margin: auto;\n  color: ", ";\n"])), function (_a) {
    var active = _a.active;
    return active ? "var(--blue)" : "var(--smoke)";
}, function (_a) {
    var active = _a.active;
    return (active ? "var(--snow)" : "var(--concrete)");
});
exports.StepLabel = styled_components_1.default.span.attrs({
    className: "StepLabel",
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var active = _a.active;
    return (active ? "var(--black)" : "var(--concrete)");
});
var templateObject_1, templateObject_2, templateObject_3;
